module.exports = __webpack_public_path__ + "img/jksy.a4cb17b0.png";